





































import { Component, Prop, Vue } from 'vue-property-decorator'
import { Service } from '@/models'
import { Utils } from '@/utils'

@Component
export default class ListProductServiceModal extends Vue {
  @Prop({ required: true, type: Array }) readonly services: Service[]

  private utils = Utils

  hideModal() {
    this.$bvModal.hide('listProductServiceModal')
  }
}
